Vue.component('admin-api-calls', {

  data () {
    return {
      apiCalls: null,
      apiCall: null,
    };
  },

  /**
   * The component has been created by Vue.
   */
  created () {
    this.getApiCalls();

    this.$on('updateApiCalls', function () {
      this.getApiCalls();
    });

    this.$on('getApiCall', function (id) {
      this.getApiCall(id);
    });
  },

  methods: {
    /**
     * Get the specified ApiCall.
     */
    getApiCall (id) {
      axios.get('/api/api-calls/' + id)
        .then(response => {
          this.apiCall = response.data.apiCall;
        });
    },

    /**
     * Get the ApiCalls.
     */
    getApiCalls () {
      let self = this;

      axios.get('/api/api-calls')
        .then(function (response) {
          self.apiCalls = response.data.apiCalls;
          if (self.apiCalls.length > 0 && self.apiCall === null) {
            self.getApiCall(self.apiCalls[0].id);
          }
        });
    },
  }
});
